<template>
    <div>
        <div style="position:fixed; bottom:160px; right: 34px; z-index: 9999;" @click="getDeviceVerification">
            <el-badge class="item bounce-animation">
                <i class="el-icon-success" style="font-size: 40px; color: #67C23A;"></i>
            </el-badge>
        </div>
        <el-dialog :visible.sync="dialogVisible" width="35%" center>
            <template #title>
                <div class="d-flex justify-content-center align-items-center ">
                    <span style="font-weight: bold; font-size: 20px;">Thiết bị đang yêu cầu đăng nhập</span>
                </div>
            </template>
            <p v-if="loading" class="text-center">
                <i class="el-icon-loading" style="font-size: 25px;"></i>
            </p>
            <div v-else-if="!confirmation" class="d-flex justify-content-between align-items-center">
                <span class="text-center">Không có thiết bị nào cần xác thực</span>
                <div class="d-flex justify-content-center mt-3">
                    <button class="btn btn-info mr-2" @click="getDeviceVerification"><i
                            class="el-icon-refresh-left"></i>Tải
                        lại</button>
                </div>
            </div>
            <div v-else>
                <div style="background-color: #f8fafc;border-radius: 5px; border: 1px solid #e2e8f0; padding: 10px">
                    <div class="pb-2">
                        <div class="d-flex align-items-center ">
                            <div class="d-flex justify-content-center align-items-center ">
                                <i class="el-icon-mobile-phone" style="font-size: 30px; "></i>
                            </div>
                            <div class="ml-3">
                                <p class="mb-0">Thiết bị</p>
                                <p class="mb-0" style="font-weight: bold;color:black">APP tư vấn viên</p>
                            </div>
                        </div>
                    </div>

                    <div style=" border-top: 1px solid #e2e8f0;  " class="pt-2">
                        <div class="d-flex align-items-center ">
                            <div class="d-flex justify-content-center align-items-center ">
                                <i class="el-icon-time" style="font-size: 30px; "></i>
                            </div>
                            <div class="ml-3">
                                <p class="mb-0">Thời gian</p>
                                <p class="mb-0" style="font-weight: bold;color:black">{{ confirmation.expires_at | formatDateTime }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center mt-3" v-if="confirmation && !loading">
                <button class="btn btn-secondary mr-2" style="width: 200px;" @click="dialogVisible = false">Hủy
                    bỏ</button>
                <button class="btn btn-info" style="width: 200px;" @click="confirmDevice">Đồng ý</button>
            </div>
            <div v-else class="d-flex justify-content-center mt-3">
                <button class="btn btn-secondary mr-2" style="width: 200px;"
                    @click="dialogVisible = false">Đóng</button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="codeDialogVisible" width="35%" center>
            <template #title>
                <span style="font-weight: bold; font-size: 20px;">Hãy nhập mã này vào thiết bị đang yêu cầu đăng
                    nhập</span>
            </template>
            <div
                style="display: flex; justify-content: center; align-items: center; flex-direction: column; width: 100%;">
                <div
                    style="background-color:#f8fafc ; border-radius: 10px;border: 1px solid #e2e8f0; padding: 10px;width: 100%;text-align: center;">
                    <p class="mb-0 d-" style="font-weight: bold;color:black;font-size:20px;">{{
                        confirmation?.code_request }}
                    </p>
                </div>
                <div style="border-radius: 20px;background-color: #FFFBEB; color:#D97706"
                    class="d-flex align-items-center p-2 mt-3">
                    <i class="el-icon-timer" style="font-size: 13px; "></i>
                    <p class="mb-0 ml-1" v-if="!expireTime.expired">Mã này sẽ hết hạn trong {{ expireTime?.text }}</p>
                    <p class="mb-0 ml-1" v-else>Mã này đã hết hạn, vui lòng hoàn tất, yêu cầu lại và nhập lại mã</p>
                </div>
                <button class="btn btn-info mt-3" style="width: 200px;" @click="codeDialogVisible = false">Hoàn
                    tất</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { GET_DEVICE_VERIFICATION } from "../../core/services/store/confirmtion/confirmtion.module";
import moment from "moment";
export default {
    name: 'LoginVerificationCard',
    components: {},
    props: {},
    data() {
        return {
            dialogVisible: false,
            loading: false,
            confirmation: null,
            codeDialogVisible: false,
            expireTime: "01:59",
            expireInterval: null,
        };
    },
    computed: {
        ...mapGetters(['currentUser']),
        ...mapState({
            errors: state => state.auth.errors
        }),
    },
    async created() { },
    mounted() { },
    beforeDestroy() { },
    watch: {},
    methods: {
        async getDeviceVerification() {
            this.dialogVisible = true;
            this.loading = true;
            try {
                const response = await this.$store.dispatch(GET_DEVICE_VERIFICATION);
                this.confirmation = response.data;
            } catch (error) {
                console.log(error.response.data, '22222222222222');
                this.confirmation = null;

            } finally {
                this.loading = false;
            }
        },
        confirmDevice() {
            this.dialogVisible = false;
            this.codeDialogVisible = true;
            this.expireInterval = setInterval(() => {
                this.expireTime = this.diffMinutesSeconds(this.confirmation?.expires_at);
                if (this.expireTime.minutes === 0 && this.expireTime.seconds === 0) {
                    clearInterval(this.expireInterval);
                    this.expireTime.expired = true;
                }
            }, 1000);
        },
        diffMinutesSeconds(utcTime) {
            const now = moment.utc();
            const target = moment.utc(utcTime);

            if (!target.isValid()) {
                return {
                    expired: true,
                    minutes: 0,
                    seconds: 0,
                    text: "Invalid date",
                };
            }

            const diffSeconds = target.diff(now, "seconds");

            if (diffSeconds <= 0) {
                return {
                    expired: true,
                    minutes: 0,
                    seconds: 0,
                    text: "Hết hạn",
                };
            }

            const minutes = Math.floor(diffSeconds / 60);
            const seconds = diffSeconds % 60;

            return {
                expired: false,
                minutes,
                seconds,
                text: `${minutes}:${String(seconds).padStart(2, "0")}`,
            };
        }
    },
}
</script>

<style scoped>
@keyframes bounce {

    0%,
    100% {
        transform: translateY(-25%);
        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
    }

    50% {
        transform: translateY(0);
        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }
}

.bounce-animation {
    cursor: pointer;
    animation: bounce 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
</style>
